import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function useCollectionNames() {

  const [allCollectionNames, setAllCollectionNames] = useState([])
  const [socialcollectionSets, setSocialCollectionSets] = useState({})
  const [retailercollectionSets, setRetailerCollectionSets] = useState({})
  const [designProductCollectionSets, setDesignProductsCollectionSets] = useState({})
  const userLoggedIn = useSelector(state => state.userLoggedIn)

  const getCollectionNames = async () => {
    let collections = []
    if (userLoggedIn.loggedIn) {
      const resp = await axios.get(`/api/saved-images/collections`)
      collections = resp.data.collections
    }
    setAllCollectionNames(collections)
    let socialcollectionSetsTemp = {}
    let retailercollectionSetsTemp = {}
    let similarProductscollectionSetsTemp = {}
    collections.forEach(coll => {
      socialcollectionSetsTemp[coll._id] = new Set(coll['savedImages']);
      retailercollectionSetsTemp[coll._id] = new Set(coll['savedProducts']);
      similarProductscollectionSetsTemp[coll._id] = new Set(coll['designProducts'] || []);
    })
    setSocialCollectionSets(socialcollectionSetsTemp)
    setRetailerCollectionSets(retailercollectionSetsTemp)
    setDesignProductsCollectionSets(similarProductscollectionSetsTemp)
  }
  useEffect(() => {
    getCollectionNames()
  }, [userLoggedIn])
  return [allCollectionNames, socialcollectionSets, retailercollectionSets, getCollectionNames, designProductCollectionSets]
}

export default useCollectionNames;
